<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-alert message="这里展示已加入再生环保推荐的商品。删除仅移出推荐；前端展示其中已上架的商品。" type="info" show-icon class="pool-notice" />
      <div class="pool-toolbar">
        <a-input-search v-model="query.keyword" placeholder="商品中文名 / 英文名" @search="search" />
        <a-select v-model="query.orderType" allow-clear placeholder="商城类型" @change="search">
          <a-select-option :value="3">现货商城</a-select-option>
          <a-select-option :value="12">定制商城</a-select-option>
        </a-select>
        <a-button v-hasPermi="['dkmall:environment:edit']" type="primary" icon="plus" @click="openPicker">新增</a-button>
      </div>
      <a-alert v-if="listError" type="error" message="推荐列表加载失败，请重试" class="pool-notice">
        <a slot="description" @click="load">重试</a>
      </a-alert>
      <a-table class="environment-pool-table" row-key="aid" :columns="columns" :data-source="rows" :pagination="pagination" :loading="loading" :scroll="{ x: 950 }" @change="changePage">
        <template slot="image" slot-scope="v"><img v-if="v" :src="v" class="goods-thumb" /><span v-else>-</span></template>
        <template slot="type" slot-scope="v">{{ Number(v) === 3 ? '现货商城' : '定制商城' }}</template>
        <template slot="sale" slot-scope="v"><a-tag v-if="Number(v) === 1" color="green">上架</a-tag><a-tag v-else>下架</a-tag></template>
        <template slot="action" slot-scope="v, row">
          <a-popconfirm v-hasPermi="['dkmall:environment:edit']" title="确定将该商品移出再生环保推荐？商品本身不会删除。" ok-text="确定" cancel-text="取消" :disabled="savingId !== null" @confirm="removeRecommendation(row)">
            <a-button type="link" :loading="savingId === row.aid" :disabled="savingId !== null && savingId !== row.aid">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
      <a-modal title="新增再生环保商品" :visible="pickerVisible" :width="1100" :destroy-on-close="true" :mask-closable="!adding" :closable="!adding" :keyboard="!adding" :body-style="{ maxHeight: '65vh', overflowY: 'auto' }" @cancel="closePicker">
        <a-tabs :active-key="String(candidateQuery.orderType)" @change="changeMall">
          <a-tab-pane key="3" tab="现货商城" />
          <a-tab-pane key="12" tab="定制商城" />
        </a-tabs>
        <div class="picker-toolbar">
          <a-input-search v-model="candidateQuery.keyword" placeholder="商品中文名 / 英文名" @search="searchCandidates" />
          <span>已选择 {{ selectedIds.length }} 件商品</span>
          <a v-if="selectedIds.length" @click="clearSelection">清空所选</a>
        </div>
        <a-alert v-if="candidateError" type="error" message="商品加载失败，请重试" class="pool-notice"><a slot="description" @click="loadCandidates">重试</a></a-alert>
        <a-alert v-if="addError" type="error" message="添加失败，请重试" :description="addError" class="pool-notice" />
        <a-table class="environment-candidate-table" row-key="aid" :columns="candidateColumns" :data-source="candidates" :pagination="candidatePagination" :loading="candidateLoading" :row-selection="rowSelection" :scroll="{ x: 800 }" @change="changeCandidatePage">
          <template slot="image" slot-scope="v"><img v-if="v" :src="v" class="goods-thumb" /><span v-else>-</span></template>
          <template slot="sale" slot-scope="v"><a-tag v-if="Number(v) === 1" color="green">上架</a-tag><a-tag v-else>下架</a-tag></template>
        </a-table>
        <template slot="footer">
          <a-button :disabled="adding" @click="closePicker">取消</a-button>
          <a-button type="primary" :loading="adding" :disabled="!selectedIds.length || adding" @click="addSelected">添加所选（{{ selectedIds.length }}）</a-button>
        </template>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import request from '@/utils/request'

const productColumns = [
  { title: '主图', dataIndex: 'thumb', width: 80, scopedSlots: { customRender: 'image' } },
  { title: '商品 ID', dataIndex: 'aid', width: 90 },
  { title: '中文名称', dataIndex: 'name', width: 250 },
  { title: '英文名称', dataIndex: 'name_en', width: 250 },
  { title: '状态', dataIndex: 'is_sale', width: 100, scopedSlots: { customRender: 'sale' } }
]

export default {
  name: 'EnvironmentRecommendation',
  data: () => ({
    query: { keyword: '', orderType: undefined, selectedOnly: true, pageNum: 1, pageSize: 20 },
    rows: [], total: 0, loading: false, listError: false, listRequest: 0, savingId: null,
    columns: [...productColumns.slice(0, 4), { title: '商城', dataIndex: 'order_type', width: 120, scopedSlots: { customRender: 'type' } }, productColumns[4], { title: '操作', key: 'action', width: 90, scopedSlots: { customRender: 'action' } }],
    candidateColumns: productColumns,
    pickerVisible: false, candidateQuery: { keyword: '', orderType: 3, pageNum: 1, pageSize: 10 },
    candidates: [], candidateTotal: 0, candidateLoading: false, candidateError: false, candidateRequest: 0,
    selectedGoods: {}, adding: false, addError: ''
  }),
  computed: {
    pagination () { return { current: this.query.pageNum, pageSize: this.query.pageSize, total: this.total, showSizeChanger: true, showTotal: n => `共 ${n} 条` } },
    candidatePagination () { return { current: this.candidateQuery.pageNum, pageSize: this.candidateQuery.pageSize, total: this.candidateTotal, showSizeChanger: true, showTotal: n => `共 ${n} 条` } },
    selectedIds () { return Object.keys(this.selectedGoods).map(Number) },
    rowSelection () {
      return {
        selectedRowKeys: this.selectedIds,
        onSelect: (row, selected) => this.selectGoods([row], selected),
        onSelectAll: (selected, selectedRows, changedRows) => this.selectGoods(changedRows, selected),
        getCheckboxProps: () => ({ props: { disabled: this.adding } })
      }
    }
  },
  created () { this.load() },
  beforeDestroy () { this.listRequest++; this.candidateRequest++ },
  methods: {
    search () { this.query.pageNum = 1; this.load() },
    changePage (p) { this.query.pageNum = p.current; this.query.pageSize = p.pageSize; this.load() },
    async load () {
      const id = ++this.listRequest
      this.loading = true
      this.listError = false
      try {
        const r = await request({ url: '/dkmall/goods/environment', method: 'get', params: { ...this.query, selectedOnly: true } })
        if (id !== this.listRequest) return
        this.rows = r.data.rows
        this.total = Number(r.data.total)
        const last = Math.max(1, Math.ceil(this.total / this.query.pageSize))
        if (this.query.pageNum > last) { this.query.pageNum = last; await this.load() }
      } catch (e) {
        if (id === this.listRequest) { this.rows = []; this.total = 0; this.listError = true }
      } finally { if (id === this.listRequest) this.loading = false }
    },
    async removeRecommendation (row) {
      if (this.savingId !== null) return
      this.savingId = row.aid
      try {
        await request({ url: `/dkmall/goods/${row.aid}/environment`, method: 'put', data: { enabled: false } })
        this.$message.success('已移出再生环保推荐')
        await this.load()
      } catch (e) { this.$message.error('删除推荐失败，请重试') } finally { this.savingId = null }
    },
    openPicker () {
      this.selectedGoods = {}
      this.addError = ''
      this.candidateQuery = { keyword: '', orderType: 3, pageNum: 1, pageSize: 10 }
      this.pickerVisible = true
      this.loadCandidates()
    },
    closePicker () {
      if (this.adding) return
      this.pickerVisible = false
      this.candidateRequest++
      this.selectedGoods = {}
    },
    changeMall (key) { this.candidateQuery.orderType = Number(key); this.candidateQuery.pageNum = 1; this.loadCandidates() },
    searchCandidates () { this.candidateQuery.pageNum = 1; this.loadCandidates() },
    changeCandidatePage (p) { this.candidateQuery.pageNum = p.current; this.candidateQuery.pageSize = p.pageSize; this.loadCandidates() },
    clearSelection () { if (!this.adding) this.selectedGoods = {} },
    selectGoods (rows, selected) {
      if (this.adding) return
      if (selected && new Set([...this.selectedIds, ...rows.map(r => Number(r.aid))]).size > 500) {
        this.$message.warning('每次最多添加500件商品')
        return
      }
      rows.forEach(row => selected ? this.$set(this.selectedGoods, row.aid, row) : this.$delete(this.selectedGoods, row.aid))
    },
    async loadCandidates () {
      const id = ++this.candidateRequest
      this.candidateLoading = true
      this.candidateError = false
      this.candidates = []
      try {
        const r = await request({ url: '/dkmall/goods/environment/candidates', method: 'get', params: { ...this.candidateQuery } })
        if (id !== this.candidateRequest || !this.pickerVisible) return
        this.candidates = r.data.rows
        this.candidateTotal = Number(r.data.total)
      } catch (e) {
        if (id === this.candidateRequest) { this.candidates = []; this.candidateTotal = 0; this.candidateError = true }
      } finally { if (id === this.candidateRequest) this.candidateLoading = false }
    },
    async addSelected () {
      if (!this.selectedIds.length || this.adding) return
      this.adding = true
      this.addError = ''
      try {
        await request({ url: '/dkmall/goods/environment', method: 'post', data: { goodsIds: this.selectedIds } })
        this.$message.success('已添加到再生环保推荐')
        this.pickerVisible = false
        this.candidateRequest++
        this.selectedGoods = {}
        await this.load()
      } catch (e) { this.addError = e.message || '请刷新商品列表后重新选择' } finally { this.adding = false }
    }
  }
}
</script>

<style scoped>
.pool-notice { margin-bottom: 16px; }
.pool-toolbar, .picker-toolbar { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin-bottom: 16px; }
.pool-toolbar .ant-input-search, .picker-toolbar .ant-input-search { width: 300px; max-width: 100%; }
.pool-toolbar .ant-select { width: 140px; }
.goods-thumb { width: 56px; height: 56px; object-fit: cover; }
</style>
